/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
//actions
import { updatePageDetails, changePage, displayMessage, displayModal } from '@insticator/insticator-ui';
// component
import Commenting from 'pages/dashboard/commenting/commenting';



/* ========== ~~~~~~~~~~ COMMENTING : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ commentingState, accountData, sessionStatus }) => ({
    permissions: sessionStatus.permissions,
    mockupGenerator: sessionStatus.mockupGenerator,
    siteUUID: sessionStatus.siteUUID,
    commentingState,
    fetchingCommentData: commentingState.commentingStatus.fetchingCommentData,
    dataFetchFailed: commentingState.commentingStatus.dataFetchFailed,
    isDataReceived: commentingState.commentingStatus.isDataReceived,
    requestStatus: commentingState.commentingStatus.requestStatus,
    hasCommentingUnit: commentingState.commentingStatus.hasCommentingUnit,
    sites: accountData.sites
});

// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Commenting));
